/** True when the media query matches. False where there is no matchMedia (jsdom, SSR). */
export default function matchesMedia(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
}
